import { render } from "./PlayerNutritionList.vue?vue&type=template&id=3ec2c0fa&scoped=true"
import script from "./PlayerNutritionList.vue?vue&type=script&lang=js"
export * from "./PlayerNutritionList.vue?vue&type=script&lang=js"

import "./PlayerNutritionList.vue?vue&type=style&index=0&id=3ec2c0fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec2c0fa"]])

export default __exports__